import { gql } from '@apollo/client';
import type { Follow } from '../../../types/following';

export const UPDATE_FOLLOWS = gql`
  mutation updateFollows($uniqueCodes: [String!]!, $eventId: ID!) {
    updateFollows(uniqueCodes: $uniqueCodes, eventId: $eventId)
      @rest(
        type: "UpdateFollowsResponse"
        path: "/v2/api/follows/{args.eventId}"
        method: "PUT"
        bodyKey: "uniqueCodes"
        endpoint: "bff"
      ) {
      data
      message
    }
  }
`;

export type UpdateFollowsVariables = {
  uniqueCodes: string[];
  eventId: number;
};

export type UpdateFollowsData = {
  updateFollows: {
    data: Follow[];
    message: string;
  };
};
